// Move this javascript code form onbrandUtilityFunctions.js file
function currentYear() {
    document.querySelector('#footer-copyright').innerHTML = new Date().getFullYear();
}
export { currentYear };


// WEBPACK FOOTER //
// ./script-partials/currentYear.js